
class SupportV2StepActionsModel

  constructor: (options= {}) ->
    @options = options

  toHash: ->
    hash =
      isV2 : true
      contToStepTwoBtnText : I18n.t("js.modules.support.contorder")
      needHelpBtnText: I18n.t("js.modules.support.needhelp")
      refundMyRequest: I18n.t("js.modules.support.req_my_refund")
      contToStepThreeBtnText: I18n.t("js.modules.support.cont")
      orderId: if Groupon.Support.currentOrder?.id? then Groupon.Support.currentOrder.id.toString() else "noorder"
      tagline: if Groupon.Support.Tagline? then Groupon.Support.Tagline else ""
      isPriorityViewsEnabled: window.priorityViewsEnabled()
      isRefundEligible: window.evaluate(Groupon.Support.ContentModel.isRefundEligible)

    if @options.showVerticalView
      hash.showVerticalView = true

    if Groupon.Support.MAXINDEX is 3
      if Groupon.Support.CURRENTVIEW.id is 1
        if Groupon.Support.currentOrder
          _.extend hash, window.getOrderInfoForBH(Groupon.Support.currentOrder)
          hash.showOrderDetailsActions = true
        else
          hash.showOrderListingActions = true
      else if Groupon.Support.CURRENTVIEW.id is 2
        hash.showChat =  Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat()
    else if Groupon.Support.MAXINDEX is 2
      if Groupon.Support.CURRENTVIEW.id is 1
        hash.showChat = Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat()

    hash

module.exports = SupportV2StepActionsModel
